const state = {
  data: {
    previous_id: null,
    current_id: null,
    loan_uuid: null
  }
}

const getters = {}

const mutations = {
  setApprovedRepeatedData (state, data) {
    state.data = data
  }
}

const actions = {}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
